import { useCallback } from 'react'
import { PostFormat, postProvider } from '@zing/shared/api'
import {ProgramInputs} from "../schemas/inputs";

type SaveOptions = {
    onSuccess?: (data: any) => Promise<void>
    onError?: (err: any) => Promise<void>
}

type PayloadFactory<T = ProgramInputs> = (data: ProgramInputs) => any

export const useSaveProgram = <T = any>(payloadFactory?: PayloadFactory<T>, options?: SaveOptions) => {
    const mutation = postProvider(options?.onSuccess, options?.onError)

    const fileToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = reject;
        });
    };

    const uploadFiles = async (image: File, challengeId: string, type: string) => {
        const fileContent = await fileToBase64(image);
        let data = {
            Mimetype: image.type,
            Name: btoa(image.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')),
            size: image.size,
            Type: type,
            Content: fileContent.substring(fileContent.indexOf(",") + 1),
        };
        let payload = {
            data: data,
        };

        const request: PostFormat = {
            url: `v1/hub/company/challenge/${challengeId}/file/upload`,
            data: payload,
        };

        return mutation.mutate(request);
    }

    const save = useCallback(async (data: ProgramInputs, challengeId: string) => {
        const payload = payloadFactory ? payloadFactory(data) : data
        console.log(data);
        console.log(payload);
        if (challengeId !== undefined) {
            payload.data.id = challengeId;
            payload.id = challengeId;
        }
        const request: PostFormat = {
            url: '/v1/hub/company/challenge',
            data: payload
        }
        const result = await mutation.mutateAsync(request);
        if (data.coverImage && data.coverImage.length > 0) {
            await uploadFiles(data.coverImage[0], result.data.id, 'coverImage');
        }
        if (data.homePageSlider && data.homePageSlider.length > 0) {
            await uploadFiles(data.homePageSlider[0], result.data.id, 'homePageSlider');
        }
        if (data.supportFiles && data.supportFiles.length > 0) {
            for (const file of data.supportFiles) {
                await uploadFiles(file, result.data.id, 'supportFiles');
            }
        }
        if (data.presentationVideo && data.presentationVideo.length > 0) {
            await uploadFiles(data.presentationVideo[0], result.data.id, 'presentationVideo');
        }
        return result;
    }, [mutation, payloadFactory])

    return {
        save,
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
        isLoading: mutation.isLoading,
        data: mutation.data,
        error: mutation.error
    }
}

export default useSaveProgram
